import { c as _c } from "react/compiler-runtime";
import 'dayjs/locale/ko';
import { Badge } from '@common/components';
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import type { GiftTrialCampaign } from '@/api/getGiftTrialCampaign';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { formatSelectionAnnounceDateTime } from '../../_utils/formatCampaignDate';
import { GiftPreviewLink } from './GiftPreviewLink';
const PHASE_BADGE = {
  UPCOMING: {
    label: '체험단 모집 예정',
    className: undefined
  },
  RECRUITING: {
    label: '체험단 모집중',
    className: 'bg-O-400 text-Gray-white'
  },
  CLOSED: {
    label: '체험단 모집 마감',
    className: 'bg-Gray-900 text-Gray-white'
  },
  SELECTED: {
    label: '체험단 모집 마감',
    className: 'bg-Gray-900 text-Gray-white'
  }
} satisfies Record<GiftTrialCampaign['campaignPhase'], {
  label: string;
  className?: string;
}>;
const FULL_DATE_FORMAT = 'YYYY년 M월 D일 (ddd)';
const FULL_DATE_TIME_FORMAT = `${FULL_DATE_FORMAT} HH시\u00A0mm분`;
export const CampaignInfoBlock = t0 => {
  const $ = _c(39);
  const {
    campaign,
    recruitDayCount,
    gift,
    isPeriodTwoLines: t1
  } = t0;
  const isPeriodTwoLines = t1 === undefined ? false : t1;
  const badge = PHASE_BADGE[campaign.campaignPhase];
  const t2 = `${campaign.recruitCount}명`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      label: "\uBAA8\uC9D1 \uC778\uC6D0",
      value: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== campaign.applyStartAt) {
    t4 = dayjs(campaign.applyStartAt).locale("ko").format(FULL_DATE_TIME_FORMAT);
    $[2] = campaign.applyStartAt;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== campaign.actualApplyEndAt) {
    t5 = dayjs(campaign.actualApplyEndAt).locale("ko").format(FULL_DATE_TIME_FORMAT);
    $[4] = campaign.actualApplyEndAt;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `${t4}\n~ ${t5}`;
  let t7;
  if ($[6] !== t6) {
    t7 = {
      label: "\uBAA8\uC9D1 \uAE30\uAC04",
      value: t6
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== campaign.selectionAnnounceDate) {
    t8 = formatSelectionAnnounceDateTime(campaign.selectionAnnounceDate, FULL_DATE_FORMAT);
    $[8] = campaign.selectionAnnounceDate;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = {
      label: "\uC120\uC815\uC790 \uBC1C\uD45C",
      value: t8
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3 || $[13] !== t7 || $[14] !== t9) {
    t10 = [t3, t7, t9];
    $[12] = t3;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const rowList = t10;
  let t11;
  if ($[16] !== badge.className || $[17] !== badge.label) {
    t11 = <Badge className={badge.className}>{badge.label}</Badge>;
    $[16] = badge.className;
    $[17] = badge.label;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== campaign.campaignPhase || $[20] !== recruitDayCount) {
    t12 = campaign.campaignPhase === "RECRUITING" ? <p className="flex items-center gap-4 font-500 text-Gray-900 typo-body4">{recruitDayCount > 0 ? <>모집 종료까지<strong className="font-700 text-O-400 typo-body3">{recruitDayCount}일</strong>남았어요.</> : <>모집이<strong className="font-700 text-O-400 typo-body3">오늘</strong>마감돼요.</>}</p> : null;
    $[19] = campaign.campaignPhase;
    $[20] = recruitDayCount;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="flex items-center gap-8">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isPeriodTwoLines || $[26] !== rowList) {
    t14 = <dl className="flex flex-col gap-12 typo-body4">{rowList.map(row => <div key={row.label} className="flex gap-16"><dt className={cn("shrink-0 text-Gray-600", isPeriodTwoLines ? "w-80" : "w-92")}>{row.label}</dt><dd className={cn("font-600 text-Gray-700", isPeriodTwoLines ? "whitespace-pre" : "mobile-tablet:whitespace-pre-line")}>{row.value}</dd></div>)}</dl>;
    $[25] = isPeriodTwoLines;
    $[26] = rowList;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <div className="flex flex-col gap-12">{t13}{t14}</div>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== campaign.institutionName || $[32] !== campaign.productName || $[33] !== campaign.productNumber || $[34] !== gift) {
    t16 = gift ? <div className="flex flex-col gap-12"><p className="bg-O-25 px-20 py-12 text-center text-O-400 typo-caption1 mobile-tablet:py-16">이 상품은 고향사랑기부 답례품으로도 제공하고 있어요.</p><GiftPreviewLink preview={{
        productNumber: campaign.productNumber,
        mainImageUrl: gift.mainImageUrl ?? undefined,
        productName: campaign.productName,
        institutionName: campaign.institutionName
      }} href={DONATION_ROUTES.GIFTS_DETAIL.pathname({
        productNumber: campaign.productNumber
      })} className={cn("group flex items-center justify-between gap-4 rounded-xsmall border border-Gray-300 bg-Gray-white px-10 py-12", INTERACTIVE_SURFACE)}><span className="flex items-center gap-6 font-500 text-Gray-900 typo-body4"><span className="relative size-60 shrink-0 overflow-hidden rounded-xsmall bg-Gray-300 mobile-tablet:size-40">{gift.mainImageUrl ? <Image src={gift.mainImageUrl} alt="" fill={true} sizes="(max-width: 1279px) 40px, 60px" className="object-cover" /> : null}</span>이 답례품 보러가기</span><SvgChevronright aria-hidden={true} className="size-18 shrink-0 text-Gray-500 transition-transform duration-150 group-hover:translate-x-1 group-focus-visible:translate-x-1 motion-reduce:transition-none" /></GiftPreviewLink></div> : null;
    $[31] = campaign.institutionName;
    $[32] = campaign.productName;
    $[33] = campaign.productNumber;
    $[34] = gift;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <section className="flex flex-col gap-24 break-keep">{t15}{t16}</section>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};